import { graphql } from "@opensea/graphql"
import { ProfileMetadataChipsFragment } from "../ProfileMetadataChips/ProfileMetadataChips.fragment"

export const ProfileHeaderMetadataChipsFragment = graphql(
  `
    fragment ProfileHeaderMetadataChips on Profile {
      address
      ...ProfileMetadataChips
    }
  `,
  [ProfileMetadataChipsFragment],
)
